<template>
	<cTable :fields="fields" :header="header" :methods="methods" :modals="modals" :footer="footer" :config="config">
		
	</cTable>
</template>

<script>
	import {
	  getList,
		del,
		update,
		add,
		getDetails,
	} from "@/api/system/deadline";
	import { getAllClient } from "@/api/user/client";
	import cTable from "@/base/common/index";
	export default {
		name:'deadline',
		components:{
			cTable
		},
		async mounted() {
			// let client = (await getAllClient()).data.payload.rows;
			// this.modals.add.fields.forEach(t=>{
			// 	if(t.key === 'client_id')t.options = client
			// })
			// this.header.searchs.forEach(t=>{
			// 	if(t.key === 'client_id')t.options = client
			// })
		},
		data() {
			return {
				config:{
				},
				methods:{
					list:getList,
					del,
					update,
					add,
					getDetails,
				},
				footer:{
				},
				header:{
					searchs:[
						{
						  key: "client_id",
						  placeholder() {
						    return this.$t("select") + this.$t("clientName");
						  },
						  component: "Select",
						  options: [],
							optionsFn:'getAllClient'
						},
					],
					btns:{
						list:[
							{
								name:this.$t('add'),
								type:'add',
								fnName:'add',
								bind:{
									type:'primary'
								}
							}
						],
						methods:{
							add(){
								this.getModal('add').open(null,function(){
									this.setTitle('add')
								})
							},
						}
					}
				},
				modals:{
					add:{
						methods:{
							ok({row,close}){
								this.$page.handleRequestMethods(row.id?'update':'add',row,true,true).then(_=>this.$page.getList(),close())
							}
						},
						config: {
							title: this.$t("add"),
							modalBind: {
								width: 600,
								draggable: true
							},
							formBind: {
								labelWidth: 120
							},
							colBind: {
								style: {
									marginBottom: "20px"
								}
							},
							rules: {
								client_id: [{required: true,trigger: "blur",type:'number'}],
								type: [{required: true,trigger: "blur",type:'number'}],
							}
						},
						grid: [
							{
								client_id:24,
								type:24,
								day_number:24,
							},
						],
						fields: [
							{
								name: () => this.$t("clientName"),
								key: "client_id",
								placeholder:this.$t('clientName'),
								component: "Select",
								options:[],
								optionsFn:'getAllClient'
							},
							{
								name: () => this.$t("Shelf type"),
								key: "type",
								placeholder:this.$t('Shelf type'),
								component: "Select",
								options:[
									{value:1,label:this.$t('original_shelves')},
									{value:5,label:this.$t('system_shelf')},
								],
							},
							{
								name: () => this.$t("deadlineDay"),
								placeholder:this.$t('deadlineDay'),
								key: "day_number",
								component: "InputNumber",
								bind: {
									step: 1,
									min: 0,
									style: {
										width: "100%"
									}
								},
								default: 0
							},
						]
					}
				},
				fields:[
					{
						name:this.$t('clientName'),
						key:'account',
						minWidth:110
					},
					{
						name:this.$t('Shelf type'),
						key:'type_name',
						minWidth:110
					},
					{
						name:this.$t('deadlineDay'),
						key:'day_number',
						minWidth:110
					},
					{
						name:this.$t('createUser'),
						key:'operator',
						minWidth:110
					},
					{
						name:this.$t('createTime'),
						key:'create_time',
						minWidth:110
					},
					{
						type: "btns",
						width: 150,
						name: () => this.$t("operation"),
						fixed: "right",
						list: [
							{
								name: () => this.$t("update"),
								type: "update",
								fnName: "updateFun",
								bind: {
									type: "success",
								},
								// id:1258
							},
							{
								name: () => this.$t("delete"),
								type: "delete",
								fnName: "deleteFun",
								bind: {
									type: "error",
								},
								// id:1259
							},
						],
						methods: {
							async updateFun({ row }) {
								this.handleRequestMethods('getDetails',row.id).then(res=>{
									this.getModal('add').open(res.payload,function(){
										this.setTitle(this.$t("update"));
									})
								})
							 
							},
							deleteFun({ row }) {
								this.$Modal.confirm({
									title:
										this.$t("whether") +
										this.$t("confirm") +
										this.$t("delete"),
									onOk: () => {
										this.handleRequestMethods("del", row, true).then((res) => {
											// this.$Message.success(res.data.msg);
											this.getList();
										});
									},
								});
							},
						},
					}
				]
			}
		},
	}
</script>

<style scoped>

</style>